// src/components/Header.js
import React from 'react';

const Header = ({ toggleMenu }) => {
    return (
        <header style={{ backgroundColor: '#6e3bc2', color: '#f0ebf8', padding: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <button onClick={toggleMenu} style={{ fontSize: '24px', background: 'none', border: 'none', color: '#f0ebf8' }}>
                &#9776;
            </button>
            {/* Logo e outros elementos do Header aqui */}
        </header>
    );
};

export default Header;
